/* global axios */
import ApiClient from '../ApiClient';

class QuotesAPI extends ApiClient {
  constructor() {
    super('planning/events', { accountScoped: true });
  }

  base(eventId) {
    return `${this.url}/${eventId}/quotes`;
  }

  getAll(eventId) {
    return axios.get(this.base(eventId));
  }

  get(eventId, id) {
    return axios.get(`${this.base(eventId)}/${id}`);
  }

  create(eventId, payload) {
    return axios.post(this.base(eventId), payload);
  }

  update(eventId, id, payload) {
    return axios.patch(`${this.base(eventId)}/${id}`, payload);
  }

  sendQuote(eventId, id, payload = {}) {
    return axios.post(`${this.base(eventId)}/${id}/send_quote`, payload);
  }

  sendPreview(eventId, id) {
    return axios.get(`${this.base(eventId)}/${id}/send_preview`);
  }

  preview(eventId, id) {
    return axios.get(`${this.base(eventId)}/${id}/preview`, {
      responseType: 'blob',
      headers: { Accept: 'text/html' },
    });
  }

  download(eventId, id, { format } = {}) {
    const params = {};
    if (format) params.format = format;
    return axios.get(`${this.base(eventId)}/${id}/download`, {
      params,
      responseType: 'blob',
    });
  }

  withdraw(eventId, id) {
    return axios.post(`${this.base(eventId)}/${id}/withdraw`);
  }

  accept(eventId, id, payload = {}) {
    return axios.post(`${this.base(eventId)}/${id}/accept`, payload);
  }

  reject(eventId, id, payload) {
    return axios.post(`${this.base(eventId)}/${id}/reject`, payload);
  }

  revise(eventId, id, payload) {
    return axios.post(`${this.base(eventId)}/${id}/revise`, payload);
  }

  archive(eventId, id) {
    return axios.post(`${this.base(eventId)}/${id}/archive`);
  }
}

export default new QuotesAPI();
